@use '../../../../design-tokens/typography/typography' as *;

@layer design-system {
  .badge {
    position: absolute;
    height: 16px;
    padding: 0 4px;
    border-radius: 4px;
    border: 1px solid var(--border-soft);
    background-color: var(--text-default);
    color: var(--text-inverse);
    @include typography-quoll;
  }
}
